import { getLocation } from '../../../../scanline/utils/location';
import { compareReading } from '../util/readings'

/** ************************************
 * UTIL - MATCH TS COMMENT
 */

export const isTestStation = ({ comment } = {}) => {
	const match =
		/TEST/gi.exec(comment) ||
		/FG\//g.exec(comment) ||
		/NG\//g.exec(comment) ||
		/CASING VENT /gi.exec(comment) ||
		/CASING VENT /gi.exec(comment) ||
		/IR\//g.exec(comment) ||
		/bad/gi.exec(comment) ||
		/no good/gi.exec(comment) ||
		/ TS/gi.exec(comment) ||
		/ TP/gi.exec(comment) ||
		/ FLC/gi.exec(comment) ||
		/ FLX/gi.exec(comment) ||
		/ PS/gi.exec(comment) ||
		/ VALVE/gi.exec(comment) ||
		/ RISER/gi.exec(comment) ||
		/ xing/gi.exec(comment) ||
		/ crossing/gi.exec(comment);
		return match && match.length && match[0];
}

/** ************************************
 * UTIL - FILTER TEST STATIONS
 */
export const _filterTestStations = (readings) => { 
	return readings.filter((ts) => isTestStation({ comment: ts.comments }));
}

/** ************************************
 * UTIL - REMOVE TEST STATION
 */
export const _removeTestStation = (testStations, reading) => { 
	const idx = testStations.findIndex((ts) => compareReading(ts, reading));
	const exists = idx > -1;
	if (!exists) {
		return testStations;
	}
	const _result = [...testStations];
	_result.splice(idx, 1);
	return _result;
}

/** ************************************
 * UTIL - ADD TEST STATION
 */
export const _addTestStation = (testStations, reading) => { 
	const _testStations = _removeTestStation(testStations, reading);
	return [..._testStations, reading];
}

/** ************************************
 * UTIL - getTimeuuid from location
 */

export const getTimeuuid = () => {
	const location = getLocation();
	const { pathname } = location;
	const parts = (decodeURI(pathname).split('?')[0]).split('/').filter(v => v);
	const idx = parts.indexOf('Show File') + 1;

	return parts[idx];
}

export const isEquivalentTestStationArrays = (a = [], b = []) => {
	if (a?.length !== b?.length) {
		return false;
	}
	return a.every((ts, idx) => compareReading(ts, b[idx]));
}
